// extracted by mini-css-extract-plugin
export default {"space":"CustomAffix_space__FKYXe"};